import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";

// Saves the referral code (localStorage + cookie 30 days) then redirects to /register.
export default function ReferralCapture() {
  const { code } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    const c = (code || "").toUpperCase();
    let days = 30;
    api.get("/referral/config").then(({ data }) => { days = data.cookie_days || 30; }).catch(() => {}).finally(() => {
      try {
        localStorage.setItem("pm_ref_code", c);
        localStorage.setItem("pm_ref_exp", String(Date.now() + days * 86400000));
        document.cookie = `pm_ref=${c};path=/;max-age=${days * 86400}`;
      } catch {}
      nav("/register", { replace: true });
    });
  }, [code, nav]);
  return null;
}

export function getSavedReferralCode() {
  try {
    const exp = parseInt(localStorage.getItem("pm_ref_exp") || "0", 10);
    if (exp && Date.now() < exp) return localStorage.getItem("pm_ref_code") || "";
    const m = document.cookie.match(/(?:^|; )pm_ref=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  } catch { return ""; }
}

export function getFingerprint() {
  try {
    const nav = window.navigator;
    const raw = [nav.userAgent, nav.language, screen.width + "x" + screen.height, new Date().getTimezoneOffset()].join("|");
    let h = 0; for (let i = 0; i < raw.length; i++) { h = (h * 31 + raw.charCodeAt(i)) | 0; }
    return "fp" + Math.abs(h).toString(36);
  } catch { return ""; }
}
